import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// 广告审核报表
export function getCreativeReportList(params) {
  return request({
    url: `${v2Host}/creative/report/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 风险广告主列表
export function getCreativePlanList(params) {
  return request({
    url: `${v2Host}/creative/warning/warning-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 广告主白名单
export function getCreativeWhitelist(params) {
  return request({
    url: `${v2Host}/creative/whitelist/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

export function saveCreativeWhitelist(data) {
  return request({
    url: `${v2Host}/creative/whitelist/save`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}

export function updateCreativeWhitelist(data) {
  return request({
    url: `${v2Host}/creative/whitelist/update`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}

export function deleteCreativeWhitelist(data) {
  return request({
    url: `${v2Host}/creative/whitelist/delete`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  })
}

// 复审计划历史
export function getCreativePlanLogList(params) {
  return request({
    url: `${v2Host}/creative/plan/log-list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 停止推送
export function cancelCreativePlan(data) {
  return request({
    url: `${v2Host}/creative/plan/cancel`,
    method: 'post',
    data,
  })
}

// 检验复审计划
export function checkCreativePlan(data) {
  return request({
    url: `${v2Host}/creative/plan/check`,
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'post',
    data,
  })
}

// 添加复审计划
export function saveCreativePlan(data) {
  return request({
    url: `${v2Host}/creative/plan/save`,
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'post',
    data,
  })
}
